var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-oauth"},[_c('div',[_c('foxy-loader'),_c('p',{staticClass:"text-lRegular color__moon mt__16"},[_vm._v(_vm._s(_vm.$t('connexion_in_progress')))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }